import {Component} from '@angular/core';
import {TabsPageContainer} from "../../../uiComponents/tabsPageContainer";

@Component({
	selector: 'app-collaboration-users-resources-tabs',
	templateUrl: './collaboration-users-resources-tabs.component.html',
})
export class CollaborationUsersResourcesTabsComponent extends TabsPageContainer {
	tabWidth = 150;
}
